<div class="sync-process-container">
  @if (isLoading) {
<div class="loading-overlay">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  <table class="gt-reclass-table table table-condensed">
    <thead>
      <tr>
        <th colspan="16" class="header-title">Sync Process</th>
      </tr>
    </thead>
  </table>

  <div class="form-section">
    <!-- Tax Year / Scenario Row -->
    <div class="controls-row">
      <div class="control-group">
        <label>Tax Year</label>
        <ap-dropdown class="sync-dropdown" [list]="filteredTaxYearDataView"
          [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'"
          [(ngModel)]="selectedTaxYearItem"
          (onSelect)="onSelectedTaxYearSelect($event)">
          @for (item of filteredTaxYearDataView; track item.value) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setFormDropdownAriaLabel(item, 'Tax Year')"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>

      @if (showscenario) {
<div class="control-group">
        <label>Scenario</label>
        <ap-dropdown class="sync-dropdown" [list]="scenarioDropDownView"
          [selectType]="'single'" [title]="'Scenario'" [hideTitleOnInput]="true" [inputAriaLabel]="'Scenario'"
          [(ngModel)]="selectedScenarioItem"
          (onSelect)="onSelectedScenarioSelect($event)">
          @for (item of scenarioDropDownView; track item.value) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setFormDropdownAriaLabel(item, 'Scenario')"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
}
    </div>

    <!-- Sync Processes Table -->
    <table class="sync-table" cellpadding="8" cellspacing="0">
      <tbody>
        <!-- Exempt Assets - FDII -->
        <tr>
          <td class="label-cell">Exempt Assets - FDII</td>
          <td>
            <button class="btn btn-info btn-sm"
                    type="button"
                    [disabled]="examScenario"
                    (click)="syncExemptAssetsConsol()">
              &nbsp; Consolidated &nbsp;
            </button>
          </td>
        </tr>

        <!-- Interest Expense -->
        <tr>
          <td class="label-cell">Interest Expense</td>
          <td>
            <button class="btn btn-info btn-sm"
                    type="button"
                    [disabled]="examScenario"
                    (click)="syncIntExpConsol()">
              &nbsp; Consolidated &nbsp;
            </button>
          </td>
        </tr>

        <!-- Research & Development -->
        <tr>
          <td class="label-cell">Research &amp; Development</td>
          <td>
            <button class="btn btn-info btn-sm"
                    type="button"
                    [disabled]="examScenario"
                    (click)="syncRnDConsol()">
              &nbsp; Consolidated &nbsp;
            </button>
          </td>
        </tr>

        <!-- Investment First Tier CFC 861 Sourcing -->
        <tr>
          <td class="label-cell">Investment First Tier CFC 861 Sourcing</td>
          <td>
            <button class="btn btn-info btn-sm"
                    type="button"
                    [disabled]="examScenario"
                    (click)="syncFirstTierCFC()">
              &nbsp; Asset Adjustments &nbsp;
            </button>
          </td>
        </tr>

        <!-- E&P Bump 861 Sourcing -->
        <tr>
          <td class="label-cell">E&amp;P Bump 861 Sourcing</td>
          <td>
            <button class="btn btn-info btn-sm"
                    type="button"
                    [disabled]="examScenario"
                    (click)="syncEPBumpSourcing()">
              &nbsp; E&amp;P Adjustments &nbsp;
            </button>
          </td>
        </tr>

        <!-- Section 250 -->
        <tr>
          <td class="label-cell">Section 250</td>
          <td class="section-250-controls">
            <ap-dropdown class="sync-dropdown" [list]="filingGroupDropWoPshipView"
              [selectType]="'single'" [title]="'Filing Group'" [hideTitleOnInput]="true" [inputAriaLabel]="'Filing Group'"
              [(ngModel)]="filingGroupSectionItem"
              (onSelect)="onFilingGroupSectionSelect($event)">
              @for (item of filingGroupDropWoPshipView; track item.value) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setFormDropdownAriaLabel(item, 'Filing Group')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>

            <ap-dropdown class="sync-dropdown" [list]="filingEnityDetailsForSectionDetailsView"
              [selectType]="'single'" [title]="'Filer LE'" [hideTitleOnInput]="true" [inputAriaLabel]="'Filer LE'"
              [(ngModel)]="filerEntitySectionItem"
              (onSelect)="onFilerEntitySectionSelect($event)">
              @for (item of filingEnityDetailsForSectionDetailsView; track item.value) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setFormDropdownAriaLabel(item, 'Filer LE')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>

            <button class="btn btn-info btn-sm"
                    type="button"
                    (click)="syncSec250Process()">
              Calculate Sec. 250 Sync
            </button>

            <button class="btn btn-info btn-sm"
                    type="button"
                    (click)="syncPostSec250Process()">
              Post-Sec. 250 Sync
            </button>
          </td>
        </tr>

        <!-- Auto Tag Creation -->
        <tr>
          <td class="label-cell auto-tag-label">Auto Tag Creation</td>
          <td class="auto-tag-controls">
            <div class="auto-tag-row">
              <div class="auto-tag-field">
                <label>Parent ME(s)</label>
                <ap-dropdown style="width:180px" [selectType]="'multiple'" [enableNgContent]="false"
                               [list]="dropdownLists['parentME']" [optionName]="'PARENT_ME_NAME'" [optionValue]="'PARENT_ME_KEY'"
                               [title]="'Select'" [inputAriaLabel]="'Parent ME'" [hideTitleOnInput]="true"
                               [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                               (onFilterResult)="onDropdownFilterResult('parentME', $event)"
                               [(ngModel)]="parentME">
                </ap-dropdown>
              </div>

              <div class="auto-tag-field">
                <label>Filing Group</label>
                <ap-dropdown class="sync-dropdown" [list]="filingGroupDropDownView"
                  [selectType]="'single'" [title]="'Filing Group'" [hideTitleOnInput]="true" [inputAriaLabel]="'Filing Group'"
                  [(ngModel)]="filingGroupItem"
                  (onSelect)="onFilingGroupSelect($event)">
                  @for (item of filingGroupDropDownView; track item.value) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [ariaLabel]="setFormDropdownAriaLabel(item, 'Filing Group')"
                      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              </div>

              <div class="auto-tag-field">
                <label>Filer LE</label>
                <ap-dropdown style="width:180px" [selectType]="'multiple'" [enableNgContent]="false"
                               [list]="dropdownLists['filerLE']" [optionName]="'FILER_LE'" [optionValue]="'FILER_LE_KEY'"
                               [title]="'Select'" [inputAriaLabel]="'Filer LE'" [hideTitleOnInput]="true"
                               [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                               (onFilterResult)="onDropdownFilterResult('filerLE', $event)"
                               [(ngModel)]="filerEntity"
                               [disabled]="!filingGroup">
                </ap-dropdown>
              </div>

              <div class="auto-tag-field auto-tag-btn">
                <button class="btn btn-info btn-sm"
                        type="button"
                        (click)="autoTagProcess()">
                  Auto Tag
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- ============ Confirmation Dialog ============ -->
@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="confirmModalConfig"
    [visible]="false"
    (confirmed)="onConfirmYes()"
    (cancelled)="onConfirmNo()"
    (closed)="onConfirmNo()">
  </gtw-confirmation-modal>
</div>
}
